import { Button, Typography } from '@mui/material';
import { useState } from 'react';
import { getBenef } from '../../../Store/storages/BeneficiarioStorage';
import LoadingApp from '../../../components/LoadingApp';
import ModalFeedBack from '../../../components/ModalFeedBack';
import { getCartaDebitoAutomatico } from '../../../services/RelatorioService';
import { base64toBlob } from '../../../utils/Base64ToBlob';
import { onlyNumbers } from '../../../utils/OnlyNumbers';
import './styles.css';
import { sxButtonConsultar, sxSubtitle } from './sxProps';
import { useAccessibility } from '../../../Store/contexts/AccessibilityContext';
import PageTitle from '../../../components/Accessibility/PageTitle';
import DefaultText from '../../../components/Accessibility/DefaultText';

function CartaDebitoAutomatico() {

  const [numCartao, setNumCartao] = useState<string>('');
  const [isLoadingPdf, setLoadingPdf] = useState<boolean>(false);
  const [modalFeedback, setmodalFeedback] = useState<null | { icon?: 'error' | 'success', title?: string, textButton?: string, subTitle?: string, action: () => void }>(null);

  const accessibility = useAccessibility();

  const getCarta = () => {
    setLoadingPdf(true);
    getCartaDebitoAutomatico()
      .then(pdf => {
        const blob = base64toBlob(pdf || '');
        const blobUrl = URL.createObjectURL(blob);
        window.open(blobUrl);
      })
      .catch(error => {
        setmodalFeedback({
          icon: 'error',
          title: 'Erro ao buscar dados',
          subTitle: error.data?.mensagem ? error.data.mensagem : 'Erro ao gerar carta de opção de débito automático',
          textButton: 'Fechar',
          action: () => setmodalFeedback(null)
        })
      })
      .finally(() => {
        setLoadingPdf(false);
      })
  }

  const onNumCartaoChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const value = event.target.value;
    if (value.length <= 17) {
      setNumCartao(onlyNumbers(value));
    }
  };

  return (
    <div className='container'>
      <LoadingApp showLoading={isLoadingPdf} />
      <ModalFeedBack
        showModal={modalFeedback ? true : false}
        icon={modalFeedback?.icon as 'success' | 'error'}
        textButton={modalFeedback?.textButton as string}
        title={modalFeedback?.title as string}
        subTitle={modalFeedback?.subTitle as string}
        handleShowModal={modalFeedback?.action}
        showButtonModal
        handleButtonModal={modalFeedback?.action}
      />
      <PageTitle marginBottom="20px" text="Carta para opção de débito automático" />
      <DefaultText text="Autorização de débito em conta-corrente" />
      <DefaultText text="A carta de autorização será aberta em uma nova janela. Caso tenha dificuldades, desabilite o bloqueador de pop-ups do seu navegador e tente novamente." />
      <div className="search-container">
        <Button
          variant='contained' sx={sxButtonConsultar}
          onClick={() => { getCarta() }}
          disabled={!(getBenef()?.tipoUsr === 'TITULA')}
          style={accessibility.buttonStyleAccessibility}
        >
          <Typography style={accessibility.buttonTextStyleAccessibility}>Gerar autorização para débito automático</Typography>
        </Button>
      </div>
      {!(getBenef()?.tipoUsr === 'TITULA') && <Typography sx={{ ...sxSubtitle, marginTop: '25px' }}>Funcionalidade disponível apenas para o titular.</Typography>}
    </div>
  )
}

export default CartaDebitoAutomatico